<template>
  <v-dialog v-model="dialog" :max-width="maxWidth"
    @click:outside="$emit('click:outside')"
    @keydown.esc="$emit('click:outside')">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on"></slot>
    </template>
    <v-card>
      <v-card-text>
        <slot name="content"></slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['maxWidth'],
  data: () => ({ dialog: false }),
  methods: {
    setDialog() {
      this.dialog = !this.dialog;
    },
  },
  events: {
    setPluginDialog: 'setDialog',
  },
};
</script>
